import getLocalStorage from "@/utils/localStorage";
import { create } from "zustand";

const localStorage = getLocalStorage();

const storage =
  localStorage && localStorage.getItem("showData")
    ? localStorage.getItem("showData") !== "false"
    : false;

const useShowDataStore = create((set) => ({
  showData: storage,

  toggleShowData: () => set((state: any) => ({ showData: !state.showData })),
}));

export const useShowData = () =>
  useShowDataStore((state: any) => state.showData);

export const useShowDataActions = () => {
  const toggleShowData = useShowDataStore((state: any) => state.toggleShowData);

  return { toggleShowData };
};
